// removed by extract-text-webpack-plugin
module.exports = {"logo":"styles-module__logo___33ZMW"};


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/components/Logo/styles.module.css
// module id = 187
// module chunks = 0